import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { OpenTofuMigrationQueueEntryNode } from "shared/Stack/OpenTofuMigration/gql";

const OpenTofuMigrationQueueTableNoteCell = ({
  item: entry,
  ...cellProps
}: TableSimpleCellProps<OpenTofuMigrationQueueEntryNode>) => (
  <TableSimpleCell {...cellProps}>
    {entry.note && <TableCellText>{entry.note}</TableCellText>}
    {!entry.note && <TableCellEmpty />}
  </TableSimpleCell>
);

export default OpenTofuMigrationQueueTableNoteCell;
